function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 35"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16426",
    d: "M13.4 3.4a10 10 0 1 0 10 10 10 10 0 0 0-10-10zm0 17.2a1.511 1.511 0 1 1 1.507-1.5 1.511 1.511 0 0 1-1.507 1.5zm1.829-12.445-.57 7.692a.21.21 0 0 1-.21.2h-2.1a.21.21 0 0 1-.21-.2l-.57-7.692a1.832 1.832 0 1 1 3.657 0z",
    transform: "translate(-3.4 -3.4)",
    style: {
      fill: "#ffb302"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorWarning);
export default __webpack_public_path__ + "static/media/error-warning.fdfdf9c6d02b5e5608eff11bbdc23169.svg";
export { ForwardRef as ReactComponent };